import { formatSymbol } from "@/utils/i18n/format-symbol";

export const chart = {
  zh: {
    // financial
    "revenue-breakdown": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 營收分布圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 營收分布圖表，深入瞭解公司各業務線或地區的收入來源，掌握企業多元成長動能。`,
    },
    EPS: {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 每股盈餘 EPS 圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `深入分析 ${formatSymbol(
          symbol
        )} 每股盈餘（EPS）變化，了解公司獲利能力與市場表現，協助投資人精準判斷。`,
    },
    "diluted-EPS": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 稀釋每股盈餘圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} 稀釋每股盈餘最新數據，評估公司真實獲利狀況，提供投資人最即時的財報資訊。`,
    },
    revenue: {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 營收趨勢圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} 最新及歷年營收圖表，掌握公司成長動能與財報重點，投資決策必備資訊。`,
    },
    "operating-income": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 營業利益圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} 營業利益數據，全面評估公司營運成果，協助投資人掌握獲利能力關鍵指標。`,
    },
    "net-income": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 淨利變化圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} 歷年及最新淨利圖表，評估公司獲利趨勢與財報表現，做出更精準的投資判斷。`,
    },
    "operating-expenses": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 營業費用圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 營業費用圖表，深入瞭解公司各項成本支出，掌握企業營運效率與獲利能力。`,
    },
    "cash-flow": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 現金流量圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 現金流量圖表，了解公司資金流入流出狀況，評估經營穩健度與財務健康。`,
    },
    "cash-and-debt": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 現金與債務圖表｜財務數據 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} 現金與債務圖表，分析公司資金實力與負債情形，全面掌握財務穩健度與風險。`,
    },

    // valuation
    "pe-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 本益比 PE Ratio 圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} 本益比（PE Ratio）歷史與最新數據，深入分析公司估值合理性，協助投資人做出明智判斷。`,
    },
    "ps-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 股價營收比 PS Ratio 圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} 股價營收比（PS Ratio）變化，評估公司市值與營收表現，掌握投資價值關鍵指標。`,
    },
    "pb-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 股價淨值比 PB Ratio 圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 股價淨值比（PB Ratio）圖表，深入了解公司市價與資產淨值的關係，評估投資風險與機會。`,
    },
    "ev-ebitda": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} EV/EBITDA 圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} EV/EBITDA 指標變化，綜合評估公司企業價值與營運效益，投資決策參考必備。`,
    },
    "ev-sales": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} EV/Sales 圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} EV/Sales 指標，了解公司企業價值與營收的關聯性，協助投資人全面分析估值水準。`,
    },
    "forward-pe": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 預估本益比圖表｜估值指標 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} 預估本益比圖表，評估公司未來獲利成長潛力，協助投資人做出明智投資決策。`,
    },
    "pe-ratio-river": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 本益比河流圖｜估值指標 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 本益比河流圖，掌握公司歷年估值區間與變化趨勢，洞察市場情緒與投資時機。`,
    },

    // growth
    "peg-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} PEG 比率圖表｜成長能力 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} PEG 比率圖表，評估公司成長潛力與估值合理性，協助投資人做出明智投資決策。`,
    },
    "eps-surprise-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} EPS 驚喜比率圖表｜成長能力 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} EPS 驚喜比率，對比市場預期與實際每股盈餘，洞察公司財報表現與市場反應。`,
    },
    "revenue-surprise-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 營收驚喜比率圖表｜成長能力 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} 營收驚喜比率圖表，分析公司公布營收與市場預期的差距，評估營運成效與市場信心。`,
    },

    // profitability
    "roe-roa": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 經營報酬率 ROE/ROA 圖表｜獲利能力 - Growin`,
      description: (symbol: string) =>
        `掌握 ${formatSymbol(
          symbol
        )} 經營報酬率（ROE/ROA）變化，深入分析公司資產與股東權益報酬，評估經營效率與獲利能力。`,
    },
    ros: {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} ROS 營業利益率 圖表｜獲利能力 - Growin`,
      description: (symbol: string) =>
        `透過 ${formatSymbol(
          symbol
        )} ROS（營業利益率）圖表，了解公司營運產出與收入比率，評估獲利結構與營運表現。`,
    },
    "profitability-ratios": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} 三率圖｜獲利能力 - Growin`,
      description: (symbol: string) =>
        `查看 ${formatSymbol(
          symbol
        )} 三率圖，全面比較毛利率、營業利益率與淨利率，掌握公司各階段獲利能力與經營成效。`,
    },
  },
  en: {
    // financial
    "revenue-breakdown": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Revenue Breakdown Chart｜Diverse Income Structure - Growin`,
      description: (symbol: string) =>
        `Explore ${formatSymbol(
          symbol
        )}'s revenue breakdown by business segment or region to uncover diversified growth drivers.`,
    },
    EPS: {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Earnings Per Share (EPS) Chart｜Key Financial Insights - Growin`,
      description: (symbol: string) =>
        `Analyze the changes in ${formatSymbol(
          symbol
        )} EPS to assess profitability and market performance, helping investors make informed decisions.`,
    },
    "diluted-EPS": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Diluted EPS Chart｜Comprehensive Financial Analysis - Growin`,
      description: (symbol: string) =>
        `Access the latest diluted EPS data for ${formatSymbol(
          symbol
        )} to evaluate true profitability, providing investors with up-to-date financial insights.`,
    },
    revenue: {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Revenue Trend Chart｜Latest Financial Data - Growin`,
      description: (symbol: string) =>
        `View the latest and historical revenue charts of ${formatSymbol(
          symbol
        )} to understand growth momentum and key financial highlights. Essential information for investment decisions.`,
    },
    "operating-income": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Operating Income Chart｜In-depth Performance Analysis - Growin`,
      description: (symbol: string) =>
        `Access ${formatSymbol(
          symbol
        )} operating income data to comprehensively evaluate business performance and key profitability metrics.`,
    },
    "net-income": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Net Income Trend Chart｜Profitability Overview - Growin`,
      description: (symbol: string) =>
        `Track historical and recent net income charts for ${formatSymbol(
          symbol
        )} to evaluate profit trends and financial performance for better investment assessment.`,
    },
    "operating-expenses": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Operating Expenses Chart｜Transparent Cost Analysis - Growin`,
      description: (symbol: string) =>
        `Review changes in ${formatSymbol(
          symbol
        )} operating expenses to understand cost management and operational efficiency in detail.`,
    },
    "cash-flow": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Cash Flow Chart｜Capital Movement & Stability - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )} cash flow charts to assess cash inflows and outflows, evaluating operational stability and financial health.`,
    },
    "cash-and-debt": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Cash & Debt Chart｜Financial Structure Overview - Growin`,
      description: (symbol: string) =>
        `View ${formatSymbol(
          symbol
        )} cash and debt charts to analyze capital strength and liabilities for a complete picture of financial stability and risk.`,
    },

    // valuation
    "pe-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} P/E Ratio Chart｜Valuation Trend Analysis - Growin`,
      description: (symbol: string) =>
        `Access historical and latest P/E Ratio data for ${formatSymbol(
          symbol
        )} to assess valuation levels and make informed investment decisions.`,
    },
    "ps-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} P/S Ratio Chart｜Value Assessment - Growin`,
      description: (symbol: string) =>
        `Review ${formatSymbol(
          symbol
        )}'s Price-to-Sales Ratio trends to evaluate market capitalization relative to revenue and key value indicators.`,
    },
    "pb-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} P/B Ratio Chart｜Asset Value Analysis - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )}'s Price-to-Book Ratio charts for insights into market price versus net asset value, assessing risk and opportunity.`,
    },
    "ev-ebitda": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} EV/EBITDA Chart｜Enterprise Value Benchmark - Growin`,
      description: (symbol: string) =>
        `Track ${formatSymbol(
          symbol
        )}'s EV/EBITDA trends to evaluate enterprise value and operational performance for investment reference.`,
    },
    "ev-sales": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} EV/Sales Chart｜Revenue & Enterprise Value Link - Growin`,
      description: (symbol: string) =>
        `Understand ${formatSymbol(
          symbol
        )}'s EV/Sales ratio to analyze the relationship between enterprise value and revenue for comprehensive valuation analysis.`,
    },
    "forward-pe": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} Forward P/E Chart｜Growth Potential - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )}'s Forward P/E to assess future earnings growth potential and make informed investment decisions.`,
    },
    "pe-ratio-river": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} P/E Ratio River Chart｜Long-term Valuation Range - Growin`,
      description: (symbol: string) =>
        `Use ${formatSymbol(
          symbol
        )}'s P/E Ratio River Chart to track historical valuation ranges and trends, helping identify market sentiment and investment timing.`,
    },

    // growth
    "peg-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(symbol)} PEG Ratio Chart｜Growth Potential - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )}'s PEG Ratio to assess growth potential and valuation, helping investors make informed investment decisions.`,
    },
    "eps-surprise-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} EPS Surprise Ratio Chart｜Earnings Expectation vs. Actual - Growin`,
      description: (symbol: string) =>
        `Track ${formatSymbol(
          symbol
        )}'s EPS Surprise Ratio to compare market expectations with actual earnings per share, revealing financial performance and market reaction.`,
    },
    "revenue-surprise-ratio": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Revenue Surprise Ratio Chart｜Revenue Expectation vs. Actual - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )}'s Revenue Surprise Ratio to evaluate the gap between reported revenue and market forecasts, assessing business results and investor confidence.`,
    },

    // profitability
    "roe-roa": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} ROE/ROA Chart｜Operational Performance Analysis - Growin`,
      description: (symbol: string) =>
        `Track ${formatSymbol(
          symbol
        )}'s ROE and ROA trends to evaluate returns on equity and assets, providing insights into management efficiency and profitability.`,
    },
    ros: {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} ROS (Operating Profit Margin) Chart｜Profitability Indicator - Growin`,
      description: (symbol: string) =>
        `Analyze ${formatSymbol(
          symbol
        )}'s ROS (Operating Profit Margin) to understand the ratio of operating profit to revenue and evaluate profitability structure and business performance.`,
    },
    "profitability-ratios": {
      title: (symbol: string) =>
        `${formatSymbol(
          symbol
        )} Profitability Ratios Chart｜Comprehensive Margin Comparison - Growin`,
      description: (symbol: string) =>
        `View ${formatSymbol(
          symbol
        )}'s Profitability Ratios Chart to compare gross margin, operating margin, and net margin, gaining a comprehensive understanding of profitability at each stage.`,
    },
  },
};
